import MyDragImage from './MyDragImage';

/**
 * 用来限制拖拽边界的
 */
export default class MyDragImageLimit extends MyDragImage {
  mousemovehandle(ev: any, target: any): void {
    super.mousemovehandle(ev, target);
    if (target && target.offsetLeft < 0) {
      target.style.left = 0;
    }
    if (target && target.offsetTop < 0) {
      target.style.top = 0;
    }
    if (target.offsetTop > this.maxHeight - target.clientHeight - 20) {
      target.style.top = this.maxHeight - target.clientHeight - 20 + 'px';
    }
    if (target.offsetLeft > this.maxWidth - target.clientWidth - 30) {
      target.style.left = this.maxWidth - target.clientWidth - 30 + 'px';
    }
  }
}
